import * as React from 'react';

import createLogger from '../../utils/createLogger';
import JobTitleEntry from './JobTitleEntry';
import {DropdownField} from "../static/Inputs";


const DEBUG = true;
const debug = createLogger(DEBUG, `JobTitleList.js`);

class JobTitleList extends React.Component {

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    this.state = {
      filterInput: ``,
      sortInput: ``,
      titleType: `include`,
    }
  }

  /* ------------ event handlers ------------ */

  onFilter = (e) => {
    e.preventDefault();
    this.setState({
      filterInput: e.target.value,
    })
  };

  // onSortChange = (field) => (input) => {
  //   this.setState({[field]: input});
  // };

  onInputChange = (field) => (input) => {
    debug.log(`setting ${field} to ${input}`, input);
    this.setState({[field]: input});
  };

  /* ------------ render ------------ */

  render () {

    const {
      titles,
      children,
      removeTitle,
      categories,
    } = this.props;

    const {
      filterInput,
      sortInput,
      titleType,
    } = this.state;

    const {
      onFilter,
      onInputChange,
    } = this;

    const jobTitleEntryConfig = {
      removeTitle,
      categories,
      titles,
    };

    const filterConfig = {
      type: `search`,
      name: `filter-titles-input`,
      value: filterInput,
      placeholder: 'Filter results...',
      onChange: onFilter,
      className: `filter-input`,
    };

    const categoryConfig = {
      className: `margin-right`,
      name: `sort-input`,
      value: sortInput,
      onChange: onInputChange(`sortInput`)
    };

    const titleTypeConfig = {
      className: `margin-right`,
      name: `sort-input`,
      value: titleType,
      onChange: onInputChange(`titleType`)
    };

    const includeTitles = titles.includes;
    const excludeTitles = titles.excludes;

    let sortedList = [];

    if (titleType === `exclude`) {
      let filteredExcludes = excludeTitles.filter(title =>
        title.title.indexOf(filterInput.toLowerCase())>-1
      );
      sortedList = (filteredExcludes ? filteredExcludes : excludeTitles).filter(title =>
        title.category.indexOf((sortInput ? sortInput : 'e'))>-1
      );
    } else {
      let filteredIncludes = includeTitles.filter (title =>
        title.title.indexOf (filterInput.toLowerCase ()) > -1
      );
      sortedList = (filteredIncludes ? filteredIncludes : includeTitles).filter (title =>
        title.category.indexOf ((sortInput ? sortInput : 'e')) > -1
      );
    };


    return (
        <main className={`job-titles-body`}>
          <div className={`job-titles-header`}>
            <div className={`job-titles-header-1`}>
              <h2>Titles</h2>
              <DropdownField {...titleTypeConfig}>
                <option value={'include'}>Include</option>
                <option value={'exclude'}>Exclude</option>
              </DropdownField>
              <DropdownField {...categoryConfig}>
                <option value={'e'}>All</option>
                {
                  categories.map((category) =>
                    <option className={"dropdown-item"} key={category} value={category}>{category}</option>
                  )
                }
              </DropdownField>
              <input {...filterConfig} />
            </div>
            <div className={`header-button-container`}>
              {children}
            </div>
          </div>

          <div className={`job-titles-list`}>
            {
              sortedList.map((title) => (
                <JobTitleEntry key={title._id}
                               _id={title._id}
                               title={title.title}
                               exclude={title.exclude}
                               category={title.category}
                               {...jobTitleEntryConfig}/>
              ))
            }
          </div>
        </main>
    )
  }
}

export default JobTitleList;



// WEBPACK FOOTER //
// ./src/components/Titles/JobTitleList.js